import { createReducer } from 'redux-act';
import { loop, Effects } from 'redux-loop';
import { fromJS } from 'immutable';
import createActions from 'modules/create-actions';

export const initialState = fromJS({
  allBrands: [],
});

export const Actions = createActions('BrandsSearchBar', [
  'loadBrandsStart', 'loadBrandsSuccess',
]);

export const loadBrands = () => {
  const loadPromise = new Promise((resolve) => {
    const interval = setInterval(() => {
      const allBrands = window.Raise.data.homepage.searchBrands;
      if (allBrands &&  Object.keys(allBrands).length !== 0) {
        clearInterval(interval);
        resolve(allBrands);
      }
    }, 500);
  });
  return loadPromise
    .then((brands) => Actions.loadBrandsSuccess(brands));
};

export const reducer = createReducer({
  [Actions.loadBrandsStart](state) {
    return loop(
      state,
      Effects.promise(loadBrands)
    );
  },

  [Actions.loadBrandsSuccess](state, brands) {
    return state.set('allBrands', brands);
  },

}, initialState);



/** WEBPACK FOOTER **
 ** ./apps/homepage/components/BrandsSearchBar/reducer.js
 **/